import store from "../index.js";
import api from "../../utils/api";
import { formatDateTransform } from "../../utils/transform";
import dayjs from "dayjs";

export const modules = {
  store,
};

export const state = {
  _subscribe: [],
  _unapprovedSubscribes: [],
  _comment: {},
  _reorder: [],
  _report: [],
  _detail: [],
  _user: [],
  _page: [],
  _unapprovedPage: [],
  _analyzeData: [],
  _subscribeChange: [],
  _subscribeRegisterChange: [],
  _subscribeRegisterChangeComplete: [],
  _subScribeAnalyze: [],
  _history: [],
  _items: {
    act_score: 0,
  },
  _commentTemplates: [],
  _reportMetadata: {},
};

export const mutations = {
  setSubscribe(state, item) {
    console.log("setSubscribe item :>> ", item);
    let userItem = [];
    let name, email, mobile;

    const items = item.subs.map(ele => {
      const { subscribe, analyze, cowStatus } = ele;
      userItem = item.users.find(index => index.userNo.includes(subscribe.userNo));
      if (userItem) {
        name = userItem.userName ? userItem.userName : userItem.userNick;
        email = userItem.email;
        mobile = userItem.mobile;
      }

      return {
        subscribe_seq: subscribe.subscribeSeq,
        subscribe_type: subscribe.subscribeType,
        analyze_seq: Number(analyze.analyzeSeq),
        report_seq: analyze.reportSeq ? Number(analyze.reportSeq) : null,
        user_no: subscribe.userNo,
        user_name: name,
        email: email,
        mobile: mobile,
        create_date: dayjs(subscribe.createDate).format("YYYY.MM.DD HH:mm:ss"),
        cow_status: cowStatus,
      };
    });
    state._subscribe = [];
    state._subscribe = [...items];

    state._page = [];
    state._page = item.page;
  },
  setUnapprovedSubscribes(state, item) {
    console.log("setUnapprovedSubscribes item :>> ", item);
    let userItem = [];
    let name, email, mobile;

    const items = item.subs.map(ele => {
      const { subscribe, analyze, cowStatus } = ele;
      userItem = item.users.find(index => index.userNo.includes(subscribe.userNo));
      if (userItem) {
        name = userItem.userName ? userItem.userName : userItem.userNick;
        email = userItem.email;
        mobile = userItem.mobile;
      }

      return {
        subscribe_seq: subscribe.subscribeSeq,
        subscribe_type: subscribe.subscribeType,
        analyze_seq: Number(analyze.analyzeSeq),
        report_seq: analyze.reportSeq ? Number(analyze.reportSeq) : null,
        user_no: subscribe.userNo,
        user_name: name,
        email: email,
        mobile: mobile,
        create_date: dayjs(subscribe.createDate).format("YYYY.MM.DD HH:mm:ss"),
        cow_status: cowStatus,
      };
    });
    state._unapprovedSubscribes = [];
    state._unapprovedSubscribes = [...items];

    state._unapprovedPage = [];
    state._unapprovedPage = item.page;
  },
  setSubscribeList(state, item) {
    let userItem = [];
    let name, email, mobile;

    const items = item.subs.map(ele => {
      userItem = item.users.find(index => index.userNo.includes(ele.userNo));
      if (userItem) {
        name = userItem.userName ? userItem.userName : userItem.userNick;
        email = userItem.email;
        mobile = userItem.mobile;
      }

      return {
        subscribe_seq: ele.subscribeSeq,
        subscribe_cart_seq: ele.subscribeCartEager[0].homeAlarmSeq,
        subscribe_type: ele.subscribeType,
        user_no: ele.userNo,
        address: ele.subscribeCartEager[0].address,
        finish_date: ele.subscribeCartEager[0].finishDate,
        user_name: name,
        mobile: mobile,
        create_date: dayjs(ele.createDate).format("YYYY.MM.DD HH:mm:ss"),
      };
    });
    state._subscribe = [];
    state._subscribe = items;

    state._page = [];
    state._page = item.page;
  },
  setSubscribeDetail(state, item) {
    item.createDate = item.createDate.replace("T", " ").replace(".000Z", "");
    item.addressBase = `${item.addressSi} ${item.addressGu} ${item.addressDong} ${
      item.buildingName ? item.buildingName : ""
    } ${item.buildingDong ? item.buildingDong : ""} ${item.buildingHo ? item.buildingHo : ""} ${
      item.buildingFloor ? item.buildingFloor : ""
    } `;

    state._detail = [];
    state._detail = Object.assign([], item);
  },
  setUserDetail(state, user) {
    state._user = user;
  },
  setSubscribeReport(state, item) {
    state._report = [];
    if (item) {
      state._report = Object.assign([], item);
    }
    console.log("setSubscribeReport", state.report[0].__reportFile__);
  },
  setSubscribeReorderList(state, item) {
    let userItem = [];
    let dateTime;
    let dateHour;
    let dueTime;
    let dueHour;
    const items = item.subs.map(ele => {
      userItem = item.users.find(index => index.userNo.includes(ele.userNo));
      dateTime = new Date(ele.createDate.replace("T", " ").replace(".000Z", ""));
      dateHour = new Date(ele.createDate.replace("T", " ").replace(".000Z", "")).getHours() + 9;

      if (ele.dueDate) {
        dueTime = new Date(ele.dueDate.replace("T", " ").replace(".000Z", ""));
        dueHour = new Date(ele.dueDate.replace("T", " ").replace(".000Z", "")).getHours() + 9;
      }

      return {
        order_seq: ele.orderSeq,
        status: ele.status,
        user_no: ele.userNo,
        user_name: !userItem ? "탈퇴유저" : userItem.userName ? userItem.userName : userItem.userNick,
        mobile: !userItem ? "탈퇴유저" : userItem.mobile,
        create_date: new Date(dateTime.setHours(dateHour)).toLocaleString(),
        due_date: ele.dueDate ? new Date(dueTime.setHours(dueHour)).toLocaleString() : null,
      };
    });
    state._reorder = [];
    state._reorder = items;
    state._page = [];
    state._page = item.page;
  },
  setIsSubscribeAnalyze(state, items) {
    state._subscribe = items;
    state._history = [];
    if (items.history?.hasOwnProperty("gapgu") && items.history?.hasOwnProperty("eulgu")) {
      let historyArray = [];
      const dateArrayGapgu = items.history.gapgu.map(item => item);
      const dateArrayEulgu = items.history.eulgu.map(item => item);
      historyArray = historyArray.concat(dateArrayGapgu, dateArrayEulgu);

      const yearData = [];
      historyArray.forEach(item => {
        const dateMatch = item?.date?.match(/(\d{4})년(\d{1,2})월/);
        if (dateMatch) {
          const year = dateMatch[1];
          const month = dateMatch[2];
          const day = dateMatch[3];
          const existingYearData = yearData?.find(data => data.year === year);

          if (existingYearData) {
            const existingMonthData = existingYearData?.data?.find(data => data.month === month);
            existingYearData.data.push({
              is: existingMonthData ? false : true,
              month: month,
              day: day,
              content: item?.content && item.content !== undefined && item.content !== "undefined" ? item.content : "",
              title: item?.title,
            });

            existingYearData.data.sort(function (a, b) {
              const aa = Number(a.month) + Number(a.day);
              const bb = Number(b.month) + Number(b.day);
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
          } else {
            yearData.push({
              year,
              data: [
                {
                  is: true,
                  month: month,
                  day: day,
                  content:
                    item?.content && item.content !== undefined && item.content !== "undefined" ? item.content : "",
                  title: item?.title,
                },
              ],
            });
          }
        }
      });
      state._history = yearData;
    }
  },
  setAnalyzeData(state, item) {
    state._analyzeData = item;
  },
  setSubscribeChange(state, item) {
    const items = item.map(item => formatDateTransform(item, ["create_date", "modify_date", "report_date"]));
    state._subscribeChange = Object.assign([], items);
  },
  setSubscribeRegisterChange(state, item) {
    const items = item.map(item => formatDateTransform(item, ["create_date", "modify_date", "report_date"]));
    state._subscribeRegisterChange = Object.assign([], items);
  },
  setSubscribeRegisterChangeComplete(state, item) {
    const items = item.map(item => formatDateTransform(item, ["create_date", "modify_date", "report_date"]));
    state._subscribeRegisterChangeComplete = Object.assign([], items);
  },

  setSubscribeAnalyze(state, item) {
    if (item) {
      state._subScribeAnalyze = formatDateTransform(item, ["createDate", "modifyDate", "reportCreateDate"]);
    }
  },
  setActScore(state, item) {
    state._items.act_score = item;
  },
  setAnalyzeFootNoteDelete(state, idx) {
    state._subScribeAnalyze?.footnote?.splice(idx, 1);
  },
  setCommentTemplates(state, items) {
    state._commentTemplates = Object.assign([], items);
  },
  setReportMetadata(state, item) {
    state._reportMetadata = Object.assign({}, item);
  },
};

export const actions = {
  async acSubscribe({ commit }, { stdate, endate, page, pageSize, email }) {
    const queries = { stdate, endate, page, pageSize, email };
    console.log("acSubscribe queries", queries);
    const url = `/api/v1/subscribe`;
    try {
      const res = await api.get(url, { params: queries });
      console.log("구독리스트", res.data);

      const userNo = [];
      res.data.data.items.forEach(item => {
        userNo.push(item.subscribe.userNo);
      });
      console.log("유저넘버정보", userNo);

      const analyze_seqs = res.data.data.items.map(item => item.subscribe.subscribeOrderReportMapEager[0].analyzeSeq);

      const analyze_url = `/api/v1/report/admin/view-type?analyze_seqs=${analyze_seqs}`;
      const analyze_data = await api.get(analyze_url);
      commit("setAnalyzeData", analyze_data.data.data);

      const user_url = `/api/v1/user/admin/order-user`;
      const users = await api.get(user_url, {
        params: {
          members: userNo,
        },
        paramSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log("유저리스트", users);

      const page = {
        pageSize: res.data.data.pageSize,
        totalCount: res.data.data.totalCount,
        totalPage: res.data.data.totalPage,
      };
      commit("setSubscribe", {
        page: page,
        subs: res.data.data.items,
        users: users.data.data,
      });

      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeUnapproved({ commit }, { page, pageSize }) {
    const queries = { page, pageSize };
    console.log("acSubscribeUnapproved queries", queries);
    const url = `/api/v1/subscribe/unapproved`;
    try {
      const res = await api.get(url, { params: queries });
      console.log("미승인 구독리스트", res.data);

      const userNo = [];
      res.data.data.items.forEach(item => {
        userNo.push(item.subscribe.userNo);
      });
      console.log("유저넘버정보", userNo);

      const user_url = `/api/v1/user/admin/order-user`;
      const users = await api.get(user_url, {
        params: {
          members: userNo,
        },
        paramSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log("유저리스트", users);

      const page = {
        pageSize: res.data.data.pageSize,
        totalCount: res.data.data.totalCount,
        totalPage: res.data.data.totalPage,
      };
      commit("setUnapprovedSubscribes", {
        page: page,
        subs: res.data.data.items,
        users: users.data.data,
      });
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeReport({ commit }, cart_seq) {
    try {
      const url = `/api/v1/subscribe-report/${cart_seq}`;
      const res = await api.get(url);

      console.log("acSubscribeReport", res);
      commit("setSubscribeReport", res.data.data);
    } catch (error) {
      console.log("acCallGet error response", error.response);
      console.log("acCallGet error request", error.request);
      console.log("acCallGet error message", error.message);
      return false;
    }
  },
  async acSubscribeList({ commit }, querys) {
    const url = `/api/v1/subscribe/admin/list`;
    try {
      const res = await api.get(url, { params: querys });
      console.log("구독리스트", res.data);

      const userNo = [];
      res.data.data.items.forEach(element => {
        userNo.push(element.userNo);
      });
      console.log("유저넘버정보", userNo);

      const user_url = `/api/v1/user/admin/order-user`;
      const users = await api.get(user_url, {
        params: {
          members: userNo,
        },
        paramSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log("유저리스트", users);

      const page = {
        pageSize: res.data.data.pageSize,
        totalCount: res.data.data.totalCount,
        totalPage: res.data.data.totalPage,
      };
      commit("setSubscribeList", {
        page: page,
        subs: res.data.data.items,
        users: users.data.data,
      });

      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeDetail({ commit }, subscribe_cart_seq) {
    try {
      const url = `/api/v1/subscribe/admin/${subscribe_cart_seq}`;
      const res = await api.get(url);

      console.log("acSubscribeDetail", res);
      commit("setSubscribeDetail", res.data.data);
      return res;
    } catch (error) {
      console.log("acCallGet error response", error.response);
      console.log("acCallGet error request", error.request);
      console.log("acCallGet error message", error.message);
      return null;
    }
  },
  async acUserDetail({ commit }, request) {
    try {
      const url = `/api/v1/user/admin`;
      const res = await api.get(url, {
        params: {
          member_no: request,
        },
      });

      commit("setUserDetail", res.data.data);
      return res;
    } catch (error) {
      console.log("acCallGet error response", error.response);
      console.log("acCallGet error request", error.request);
      console.log("acCallGet error message", error.message);
      return null;
    }
  },
  async acSubscribeFileSave({}, forms) {
    const url = `/api/v1/subscribe-file/admin/save`;

    console.log("forms", forms);
    try {
      const res = await api.post(url, forms);
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeFileDocumentSave({}, body) {
    const url = `/api/v1/subscribe-file/admin/document-save`;

    console.log("body", body);
    try {
      const res = await api.post(url, body);
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeReportFileUpdate({ commit }, forms) {
    const url = `/api/v1/subscribe-file/admin/update`;
    console.log("forms", forms);
    try {
      const res = await api.patch(url, forms);
      return res;
    } catch (err) {
      console.log("err", err);
      return null;
    } finally {
      console.log(commit);
    }
  },

  async acSubscribeNoti({ commit }, page) {
    const url = `/api/v1/subscribe-report/notification`;
    try {
      await api.post(url, { page: page });
      return true;
    } catch (err) {
      console.log("err", err);
      console.log(commit);
      return false;
    }
  },

  async acSubscribeReorderList({ commit }, querys) {
    const url = `/api/v1/subscribe/reorder/list`;
    try {
      const res = await api.get(url, { params: querys });
      console.log("재결제리스트", res.data);

      const userNo = [];
      res.data.data.items.forEach(element => {
        userNo.push(element.userNo);
      });
      console.log("유저넘버정보", userNo);

      const user_url = `/api/v1/user/admin/order-user`;
      const users = await api.get(user_url, {
        params: {
          members: userNo,
        },
        paramSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log("유저리스트", users);

      const page = {
        pageSize: res.data.data.pageSize,
        totalCount: res.data.data.totalCount,
        totalPage: res.data.data.totalPage,
      };
      commit("setSubscribeReorderList", {
        page: page,
        subs: res.data.data.items,
        users: users.data.data,
      });

      return res.data;
    } catch (err) {
      console.log("err", err);
      return null;
    }
  },
  async acSubscribeReorder({}, body) {
    const url = `/api/v1/subscribe/reorder`;

    console.log("body", body);
    try {
      const res = await api.post(url, body);
      return res.data.message;
    } catch (err) {
      console.log("err", err);
      return err.data.message;
    }
  },

  async acSubscribeAlarm() {
    const url = `/api/v1/subscribe/subscribe-free/alarm`;
    try {
      const res = await api.post(url);
      return true;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  },

  async acIsSubscribeAnalyzeDetail({ commit }, id) {
    console.log("idㅇㅇㅇㅇㅇㅇㅇㅇㅇ", id);
    const url = `/api/v1/subscribe/preview/${id}`;
    try {
      const res = await api.get(url);

      console.log("acIsSubscribeAnalyzeDetail", res.data.data);
      commit("setIsSubscribeAnalyze", res.data.data[0]);
      return true;
    } catch (error) {
      console.log("acIsSubscribeAnalyzeDetail error", error);
      return false;
    }
  },
  async acSubscribeOrderCancel({}, subscribe_seq) {
    const url = `/api/v1/subscribe-cancel/${subscribe_seq}`;
    try {
      await api.patch(url);
      return [true, "success"];
    } catch (err) {
      console.log("err", err);
      return [false, err.data.message];
    }
  },
  async acSubscribeChange({ commit }) {
    const url = `/api/v1/subscribe/detection-changes`;
    try {
      const res = await api.get(url);
      commit("setSubscribeChange", res.data.data);
      return true;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  },

  async acSubscribeRegisterChange({ commit }) {
    const url = `/api/v1/subscribe/occurrence-changes`;
    try {
      const res = await api.get(url);
      console.log("변동발생-등기확인", res.data.data);
      commit("setSubscribeRegisterChange", res.data.data);
      return true;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  },

  async acSubscribeRegisterChangeComplete({ commit }) {
    const url = `/api/v1/subscribe/occurrence-changes/complete`;
    try {
      const res = await api.get(url);
      console.log("등기변경완료", res.data.data);
      commit("setSubscribeRegisterChangeComplete", res.data.data);
      return true;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  },

  async acSubscribeAnalyzeChange({ commit }, analyze_seq) {
    try {
      const url = `/api/v1/subscribe-analyze/${analyze_seq}`;
      const res = await api.get(url);
      commit("setSubscribeAnalyze", res.data.data);
      return true;
    } catch (error) {
      console.log("acIsSubscribeAnalyzeDetail error", error);
      return false;
    }
  },

  async acSubscribeMessage({}, params) {
    console.log("알림톡 bodybody", params);
    const analyze_seq = params.analyze_seq;
    const body = {
      type: params.type,
      template_id: params.template_id,
    };

    try {
      const url = `/api/v1/subscribe/message/${analyze_seq}`;
      const res = await api.post(url, body);

      console.log("message", res.data);
      return res.data;
    } catch (error) {
      console.log("message error", error);
      return false;
    }
  },

  async acNotificationStatus({}, id) {
    try {
      const url = `/api/v1/subscribe-notification/status/${id}`;
      const res = await api.patch(url, id);
      return res.data.code === 0 ? true : false;
    } catch (error) {
      return false;
    }
  },
  async acSubscribeAnalyzeMemoSave({ commit }, params) {
    try {
      const url = `/api/v1/subscribe-analyze/admin/cs/memo`;
      const res = await api.post(url, params);

      if (!res.data.message === "success") {
        return false;
      }
      return true;
    } catch (error) {
      console.log("error아아아아", error);
      return false;
    }
  },
  async acReportPreviewAuth({}, querys) {
    const url = `/api/v1/user/subscribe-preview/auth?member_no=${querys.user_no}&analyze_seq=${querys.analyze_seq}`;
    try {
      const res = await api.get(url);
      if (res?.data?.code === 0) {
        return res.data.data?.token;
      }
      return false;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  acActScore({ commit }, item) {
    commit("setActScore", item);
  },
  async acAnalyzeFootNote({}, body) {
    const url = `/api/v1/subscribe-analyze-footnote`;
    try {
      await api.post(url, body);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acAnalyzeFootNoteDelete({ commit }, params) {
    const url = `/api/v1/subscribe-analyze-footnote/${params.seq}`;
    try {
      const res = await api.delete(url);
      if (res.data.code === 0) {
        commit("setAnalyzeFootNoteDelete", params.idx);
      }
      return true;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acAnalyzeCommentTemplates({ commit }, body) {
    const url = `/api/v1/subscribe-analyze-comment/templates`;
    try {
      const res = await api.get(url, body);
      if (res.data.code === 0) {
        commit("setCommentTemplates", res.data.data);
      }
      return res.data;
    } catch (err) {
      console.log("err", err.message);
      return null;
    }
  },
  async acSubscribeUpdateLog({}, paylod) {
    const url = `/api/v1/subscribe-cow-log/update`;
    window.console.log("POST ", url, paylod);
    try {
      await api.post(url, paylod);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acReportMetadata({ commit }, report_seq) {
    const url = `/api/v1/report/${report_seq}/metadata`;
    try {
      const res = await api.get(url);
      commit("setReportMetadata", res.data.data);
      return true;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acRequestSubscribeBatchAutoApprove(context, params) {
    const url = `/api/v1/subscribe-analyze-action/auto-approve`;
    try {
      const res = await api.post(url);
      return res.data.code === 0 ? true : false;
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },

  // --- 등기이력 수동입력 (NZSC-2580) ---

  async acDeunggiHistoryGet({}, analyze_seq) {
    try {
      const url = `/api/v1/subscribe-analyze/history/${analyze_seq}`;
      const res = await api.get(url);
      return res.data.data;
    } catch (error) {
      console.log("acDeunggiHistoryGet error", error);
      return null;
    }
  },

  async acDeunggiHistoryParse({}, registry_text) {
    try {
      const url = `/api/v1/subscribe-analyze/history/parse`;
      const res = await api.post(url, { registry_text });
      return res.data.data;
    } catch (error) {
      console.log("acDeunggiHistoryParse error", error);
      return null;
    }
  },

  async acDeunggiHistorySave({}, { analyze_seq, content }) {
    try {
      const url = `/api/v1/subscribe-analyze/history/${analyze_seq}`;
      const res = await api.put(url, { content });
      return res.data.statusCode === 200;
    } catch (error) {
      console.log("acDeunggiHistorySave error", error);
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
